import { PixelIcon } from "./PixelIcon";

export function RotateOverlay() {
  return (
    <div
      className="rotate-overlay"
      data-testid="rotate-overlay"
      role="status"
      aria-live="polite"
    >
      <PixelIcon name="phone" size={48} />
      <span>Turn your phone upright</span>
    </div>
  );
}
